<template>
  <div>
    <!-- <div class="headerNav">
      <div class="nav">
        <div class="nav_content">试看</div>
      </div>
      <div class="nav-left" @click="goBack"><img src="../../assets/new/left_b.svg" alt="" /></div>
    </div> -->
    <div style="background: #000;">

      <div v-show="!ccShow"
           id="videoPlayer"
           style="width: 100%; height: 100%"
           class="video-js videoBox"
           muted
           @contextmenu.prevent="handleContextMenu"></div>
      <div v-show="ccShow"
           id="videoPlayer2"
           style="width: 100% !important; height: 211px !important;margin-top: 50px;"
           class="video-js videoBox"></div>
    </div>
    <div class="videoNme">
      <div class="name">{{ videoInfo.chapterTitle }}</div>
      <div class="hangye">所属课程：{{ courserName }}</div>
    </div>

    <div class="tab">
      <div class="tablan active">
        温馨提示
        <div class="bor"></div>
      </div>
    </div>
    <div class="wxts"
         v-if="isZYPX">
      <div>1.学习前务必填写完整的个人信息，否则无法登记学时证明；</div>
      <div>2.如果视频无法播放，推荐使用QQ浏览器；</div>
      <div>3.课程通过后可自主打印学时证明；</div>
      <div>4.如您需要发票请到缴费订单管理界面申领电子发票。</div>
      <div>5.所报名班级下的所有课程全部学习完成才能生成证书。</div>
    </div>
    <div class="wxts"
         v-if="!isZYPX">
      <div>1.如果视频无法播放，推荐使用QQ浏览器；</div>
      <div>2.如您需要发票请到缴费订单管理界面申领电子发票。</div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import 'xgplayer';
import HlsPlugin from 'xgplayer-hls';
import Player from 'xgplayer';
import { toTryLookCourse } from '@/api/classDetail';
import { Dialog } from 'vant';
import router from '../../router';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      player: null,
      tabIndex: '1',
      videoInfo: {},
      isZYPX: true,
      courserName: '', //所属课程
      ccShow: false
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //返回
    // goBack() {
    //   if (this.$route.query.index) {
    //     console.log(1);

    //     localStorage.setItem('scrollPosition', 1);
    //      this.$router.push('/');
    //   } else {
    //     this.$router.go(-1);
    //   }
    // },
    handleContextMenu() {
      this.$utils.showToast('右击被禁用！');
    },
    getVideo(videoUrl) {
      console.log(videoUrl, 'videoUrl');
      if (videoUrl.viewId && videoUrl.viewId !== '' && videoUrl.viewId !== null) {
        // if (videoUrl.viewId !== '') {
        setTimeout(() => {
          //是cc视频的,清空西瓜
          // this.player.destroy(this.playerId);
          let elems = document.getElementById('videoPlayer2');
          let data = {
            vid: videoUrl.viewId,
            // vid: '83629B3626217CDC63835A29B2A11961',
            siteid: videoUrl.stateId,
            autoStart: true,
            // realAutoPlay:true,
            parentNode: elems,
            rate_allow_change: false,
            showFullScreenBtn: false,
            freeTime: 300,
            freeTimeEndTip: { msg: '购买课程后可继续观看' },
            progressbar_enable: 1, //0禁止拖动，1可以拖动
            closeHistoryTime: 1,
            watchStartTime: 0 //断点续播
          };
          this.ccShow = true;
          setTimeout(() => {
            this.player = createCCH5Player(data);
            if (this.player !== undefined && this.player !== null) {
              this.player.play();
            }
          }, 1000);
        }, 1000);
        return false;
      }
      if (this.player !== null) {
        this.player.destroy('videoPlayer');
      }
      if (videoUrl.isZjw == '1' || videoUrl.isYlx == '1') {
        this.player = new Player({
          id: 'videoPlayer',
          autoplay: true,
          playsinline: true,
          fullscreen: false,
          url: videoUrl.launch,
          progressDisabled: true
        });
      } else {
        // 判断视频源是否是 m3u8 格式
        if (/\.m3u8$/.test(videoUrl.launch)) {
          this.player = new Player({
            id: 'videoPlayer',
            autoplay: true,
            playsinline: true,
            url: videoUrl.launch,
            fullscreen: false,
            progressDisabled: true,
            plugins: [HlsPlugin] // 第二步
          });
        } else {
          let url = videoUrl.launch + '.mp4';
          this.player = new Player({
            id: 'videoPlayer',
            autoplay: true,
            playsinline: true,
            fullscreen: false,
            url: url,
            progressDisabled: true
          });
        }
      }
      let _this = this;
      _this.player.on('loadstart', function () {});
      _this.player.on('progress', function () {});
      _this.player.on('loadedmetadata', function () {});
      _this.player.on('canplaythrough', function () {});
      _this.player.on('waiting', function () {});
      _this.player.on('play', function () {});
      _this.player.on('playing', function () {});
      _this.player.on('pause', function () {});
      _this.player.on('ended', function () {});
      _this.player.on('error', function () {
        console.log('加载错误');
      });
      _this.player.on('seeking', function () {});
      _this.player.on('seeked', function () {});
      _this.player.on('ratechange', function () {});
      _this.player.on('timeupdate', function (e) {
        _this.timeupdate();
      });
      _this.player.on('volumechange', function () {
        console.log('音量改变');
      });
      _this.player.on('stalled', function () {
        console.log('网速异常');
      });
    },
    timeupdate() {
      if (this.player.currentTime > 300) {
        this.player.currentTime = 0;
        Dialog.confirm({
          title: '温馨提示',
          message: '试看五分钟已结束，请点击确定按钮返回购买完整课程后继续观看！'
        })
          .then(() => {
            this.$router.back();
          })
          .catch(() => {
            // on cancel
          });
        return false;
      }
    },
    toTryLookCourse(id) {
      toTryLookCourse({ cwId: id }).then(res => {
        console.log(res.data.data);
        this.videoInfo = res.data.data;
        this.getVideo(this.videoInfo);
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.isZYPX == '02') {
      this.isZYPX = false;
    } else {
      this.isZYPX = true;
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.toTryLookCourse(this.$route.query.id);
    this.courserName = this.$route.query.name;
  },
  destroyed() {
    if (this.player !== null) {
      this.player.destroy('videoPlayer');
    }
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
#videoPlayer {
  margin-top: 50px;
  width: 100% !important;
  height: 211px !important;
}
.videoNme {
  width: 100%;
  height: 84px;
  background: #ffffff;
  border-radius: 0px 0px 8px 8px;
  padding: 20px 15px;
  .name {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #333333;
    font-size: 16px;
  }
  .hangye {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #999999;
    margin-top: 7px;
    font-size: 13px;
  }
}

.tab {
  display: flex;
  margin-top: 28px;
  padding: 0 15px;
  .tablan {
    position: relative;
    margin-right: 26px;
    font-size: 15px;
    color: #333;
    .bor {
      position: absolute;
      bottom: 2px;
      left: 0;
      width: 64px;
      height: 5px;
      background: linear-gradient(90deg, #2a70f2 0%, rgba(42, 112, 242, 0) 100%);
      border-radius: 0px 0px 0px 0px;
    }
  }
  .active {
    font-size: 16px;
    font-weight: 600;
  }
}

.chaper {
  margin-top: 12px;
  background: #fff;
  width: 100%;
  min-height: 498px;
  padding: 15px;
  .zjBox {
    margin-bottom: 35px;
    .activeTitle {
      background: #2a70f2 !important;
      color: #fff !important;
    }
    .activeColor {
      color: #2a70f2 !important;
    }
    .activeBtn {
      background: #2a70f2 !important;
      color: #fff !important;
    }
    .zjIndex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bq {
        width: 48px;
        height: 24px;
        background: #f6f8fa;
        border-radius: 4px 4px 4px 4px;
        color: #666666;
        font-size: 13px;
        text-align: center;
        line-height: 24px;
      }
      .wcd {
        color: #9d9d9d;
        font-size: 12px;
      }
    }
    .chName {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333333;
      margin: 10px 0 1px 0;
      font-weight: 500;
    }
    .xsOrBtn {
      display: flex;
      justify-content: space-between;
      .xs {
        margin-top: 8px;
        color: #999999;
        font-size: 13px;
      }
      .btn {
        width: 74px;
        height: 32px;
        background: #f3f3f5;
        border-radius: 27px 27px 27px 27px;
        text-align: center;
        line-height: 32px;
        font-size: 13px;
        color: #2a70f2;
      }
    }
  }
}

.wxts {
  margin-top: 12px;
  background: #fff;
  width: 100%;
  padding: 20px 15px;
  color: #666666;
  font-size: 13px;
  line-height: 25px;
}
.headerNav {
  position: fixed;
  top: 0;
  width: 100%;
  height: 46px;
  background: #fff;
  border-radius: 0px 0px 0px 0px;
  z-index: 99;
}
.nav {
  padding: 0 15px;
  height: 46px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.nav-left {
  position: absolute;
  top: 15px;
  left: 15px;
}
.nav_content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 17px;
  color: #333;
}
</style>
